import { useCallback } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

/**
 * Hook to remove specified URL parameters from the current URL without causing a page reload.
 * This is useful for cleaning up tracking parameters (like utm_source, cart) after they've been processed.
 */
export const useClearUrlParams = () => {
  const navigate = useNavigate()
  const { search } = useLocation()

  const clearUrlParams = useCallback(
    (paramNames: string[]) => {
      const queryParams = new URLSearchParams(search)

      // Remove each specified parameter from the URL
      paramNames.forEach((param) => {
        queryParams.delete(param)
      })

      // Navigate to the same path with updated query parameters
      // Using replace: true prevents adding a new history entry
      const to = { search: queryParams.toString() }
      navigate(to, { replace: true })
    },
    [navigate, search]
  )

  return clearUrlParams
}
